/* eslint-disable */
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { storeActive } from 'ggApp/modules/store/selectors';

import {
    registerTeaserClickEvent,
    registerTeaserImpressionEvent,
    registerTeaserClickProductEvent,
} from 'ggApp/modules/gaAnalytics/actions';
import withIntersectionObserver from 'ggApp/modules/tracking/hocs/withIntersectionObserverV2';
import Widget from './ProductCarouselWidget';

const ProductCarouselWidget = compose(
    connect(
        createStructuredSelector({
            store: storeActive,
        }),
        dispatch => ({
            _registerTeaserClickProductEvent: bindActionCreators(
                registerTeaserClickProductEvent,
                dispatch
            ),
        })
    ),
    withProps(
        ({
            cta: { url },
            title,
            _registerTeaserClickProductEvent,
            firstIndexProduct,
            products,
        }) => ({
            onEnterCallback: registerTeaserImpressionEvent({ url, title }),
            onClickCTA: registerTeaserClickEvent({ url, title }),
            onClickProduct: productIndex =>
                _registerTeaserClickProductEvent({
                    url,
                    title,
                    firstIndexProduct,
                    productIndex,
                }),
            threshold: products.length > 8 ? 0.5 : 0.8,
        })
    ),
    withIntersectionObserver
)(Widget);

export default ProductCarouselWidget;
